'use client';

import { Button, Flex } from '@radix-ui/themes';
import { signIn } from 'next-auth/react';

export default function SignUpForm() {
  return (
    <Flex direction="column" gap="2">
      <Button type="submit" size="3" variant="solid" onClick={() => signIn('google')} className="bg-rose-500">
        Sign up with Google
      </Button>
      <Button type="submit" size="3" variant="solid" onClick={() => signIn('apple')} className="bg-black text-white">
        Sign up with Apple
      </Button>
    </Flex>
  );
}
